export class AllErrorResponse {
  [key: string]: unknown;
}
